import { createContext, useContext, type ReactNode } from "react";

export type ThemeScope = "admin" | "investor" | null;

const ThemeScopeContext = createContext<ThemeScope>(null);

export function ThemeScopeProvider({
  scope,
  children,
}: {
  scope: ThemeScope;
  children: ReactNode;
}) {
  return (
    <ThemeScopeContext.Provider value={scope}>
      {children}
    </ThemeScopeContext.Provider>
  );
}

export function useThemeScope(): ThemeScope {
  return useContext(ThemeScopeContext);
}
